import React from 'react'
import { DetailViewWrapper } from '~/components/compositional/CommonWrappers'
import {
  Content,
  Details,
  SubHeading,
} from '~/components/compositional/DetailViewStyles'
import { Text } from '~/components/core'
import { FontStyle } from '~/components/core/Text'
import { LazyPdfViewer } from '~/components/Pdfs/LazyPdfViewer'

import { useFaxPageQueryParams } from './hooks/useFaxPageQueryParams'

interface FaxDetailHeaderProps {
  name: string
  timestamp: string
  selectedVirtualFaxName?: string
}
export const FaxDetailHeader = ({
  name,
  timestamp,
  selectedVirtualFaxName,
}: FaxDetailHeaderProps) => {
  return (
    <Details>
      <Text
        fontStyle={FontStyle.MediumBold}
        text={name}
        color="var(--chakra-colors-fg-default)"
      />
      <SubHeading>
        <Text
          fontStyle={FontStyle.Small}
          text={timestamp}
          color="var(--chakra-colors-fg-subtle)"
        />
        <Text
          style={{ marginLeft: '4px' }}
          fontStyle={FontStyle.bSmall}
          text={selectedVirtualFaxName ?? ''}
          color="var(--chakra-colors-fg-muted)"
        />
      </SubHeading>
    </Details>
  )
}

interface FaxDetailViewProps {
  fileUrl: string
  fileName: string
  onFaxPdfLoaded?: (numPages: number) => void
  onPageChange?: (pageNumber: number) => void
}
export const FaxDetailView = ({
  fileUrl,
  fileName,
  onFaxPdfLoaded,
  onPageChange,
}: FaxDetailViewProps) => {
  const { page } = useFaxPageQueryParams()
  return (
    <DetailViewWrapper>
      <Content>
        <LazyPdfViewer
          file={fileUrl}
          filename={fileName}
          pageNumber={page}
          onFaxPdfLoaded={onFaxPdfLoaded}
          onPageChange={onPageChange}
        />
      </Content>
    </DetailViewWrapper>
  )
}
